import React, {useEffect, useState} from 'react';
import { baseUrl } from '../components/BaseUrl';
import { paystackUrl } from '../components/PaystackUrl';
import axios from 'axios';
import Swal from "sweetalert2";


const VerifyPayment = () => {
 const [loading, setLoading] = useState(false);

 useEffect(() => {
   confirmPayment();
 },[])

 const confirmPayment = () => {
   setLoading(true)
   if(localStorage.getItem("codefussion-payment-reference")){
   axios.get(`${paystackUrl}transaction/verify/${localStorage.getItem("codefussion-payment-reference")}`,
   { headers:
     { Accept: "application/json",
       "Content-Type": "application/json",
       Authorization: `Bearer sk_live_0467bebf073f41642820b763ec059700b432deb4`
     }
   })
  .then(response => {
    if(response.data.message === "Verification successful"){
      saveTransaction();
    }else{
      Swal.fire({
        title: "Error",
        text: "An error occurred. Please try again later or contact support.",
        icon: "error",
        confirmButtonText: "OK",
        backdrop: `
        rgba(143, 70, 0, 0.3)
        url("")
        left top
        no-repeat
      `
      });
      setLoading(false);
    }
   })
  .catch((error) => {
    Swal.fire({
      title: "Error",
      text: "An error occurred. Please try again later.",
      icon: "error",
      confirmButtonText: "OK",
      backdrop: `
      rgba(143, 70, 0, 0.3)
      url("")
      left top
      no-repeat
    `
    });
    setLoading(false);
   });
 }else{
 setLoading(false);
   Swal.fire({
     title: "Error",
     text: "An error occurred.",
     icon: "error",
     confirmButtonText: "OK",
     backdrop: `
     rgba(143, 70, 0, 0.3)
     url("")
     left top
     no-repeat
   `
 }).then(()=> {
     window.location.replace("/dashboard")
 });
 }
 }


 const saveTransaction = () => {
   // if(localStorage.getItem("codefussion-payment-reference")){
 const token = localStorage.getItem("codefussion-login-token");
     setLoading(true);
     const userData = {
       first_name: localStorage.getItem("codefussion-student-first-name"),
       last_name: localStorage.getItem("codefussion-student-last-name"),
       email: localStorage.getItem("codefussion-student-email"),
       reference: localStorage.getItem("codefussion-payment-reference"),
       access_code: localStorage.getItem("codefussion-payment-code"),
     };
     axios.post(`${baseUrl}create-subscriber.php`, userData,
       { headers:
       { Accept: "application/json",
         "Content-Type": "application/json",
         Authorization: token
       }
     }).then((response) => {

       if(response.data.status === 0){
         setLoading(false);
         Swal.fire({
           title: "Error!",
           text: "An error occurred. Please try again later.",
           icon: "error",
           confirmButtonText: "OK",
           backdrop: `
           rgba(143, 70, 0, 0.3)
           url("")
           left top
           no-repeat
         `
         });
        window.location.replace("/dashboard")
       }else if(response.data.status === 1){
         localStorage.removeItem("codefussion-payment-reference")
         localStorage.removeItem("codefussion-payment-code")
         let timerInterval
         Swal.fire({
         title: 'Payment Verified',
         icon: "success",
         html: 'Redirecting in <b></b> milliseconds.',
         timer: 1000,
         timerProgressBar: true,
         didOpen: () => {
           Swal.showLoading()
           const b = Swal.getHtmlContainer().querySelector('b')
           timerInterval = setInterval(() => {
             b.textContent = Swal.getTimerLeft()
           }, 100)
         },
         willClose: () => {
           clearInterval(timerInterval)
         }
       }).then((result) => {
         if (result.dismiss === Swal.DismissReason.timer) {
           localStorage.removeItem("codefussion-payment-reference")
           window.location.replace("/check-subscription")
         }
       })
          setLoading(false);
       }
     });
   };

   return(
     <div>
       {localStorage.getItem("codefussion-login-token") === null ? window.location.replace("/login") :
       <div>
     {loading ?  <center>
         <div className="loader-wrapper" id="loading">
         <div className="loader">
         <div className="loader loader-inner"></div>
         </div>
         </div>
         </center> : null }
     </div>
     }
     </div>
   )

}

export default VerifyPayment;
